import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
  OnInit,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MenuItem, MessageService, SelectItem } from "primeng/api";
import { Tender_Type } from "src/app/core/settings/business-settings/tender-type/tender-type";
import { AppSettingsStorageService } from "../../../../shared/app-settings-storage.service";
import {
  PrintingFactoryService,
  PrintingMgr,
  ReceiptPrintingSize,
} from "../../../../shared/services/printing-service.service";
import { WebHelpers } from "../../../../utility/WebHelpers";
import { DocState } from "../../doc/doc";
import { StoreSettingEmail } from "src/app/core/settings/store-settings/store-mail-settings/StoreSettingEmail";
import { Subscription } from "rxjs";
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Router } from "@angular/router";

import { AlertMessagesService } from "src/app/shared/services/alert-messages.service";
import * as _ from "lodash";
import { MonerisService } from "src/app/core/settings/integration-settings/moneris-terminal/moneris.service";
import { TakuPayService } from "src/app/core/settings/integration-settings/taku-pay/taku-pay.service";
import { pairwise } from "rxjs/operators";
import { DBService } from "src/app/shared/services/db.service";
import moment from "moment";
import { OverlayPanel } from "primeng/overlaypanel";
import { Clipboard } from "@angular/cdk/clipboard";
import { AccountDialogWrapperComponent } from "src/app/core/contact-accounts/account-dialog-wrapper/account-dialog-wrapper.component";
import { ACTION_TYPE, BUTTON_SIZE } from "src/app/shared/components/action-button/action-type.enum";
import { PurchaseDoc } from "../purchase-document/purchase-document";

enum DialogName {
  PRINT_PREVIEW = "printPreview",
}

@Component({
  selector: "taku-purchase-document-preview",
  templateUrl: "./purchase-document-preview.component.html",
  styleUrls: ["./purchase-document-preview.component.scss"],
})
export class PurchaseDocumentPreviewComponent implements OnInit {
  public ACTION_TYPE: typeof ACTION_TYPE = ACTION_TYPE;
  public BUTTON_SIZE: typeof BUTTON_SIZE = BUTTON_SIZE;
  subsList: Subscription[] = [];
  ReceiptPrintingSize = ReceiptPrintingSize;
  @Input() _object;
  @Input() accountName;
  @Output() dialogClosed: EventEmitter<any> = new EventEmitter();
  @Output() changedForm: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("printPreviewHost", { read: ViewContainerRef, static: true }) printPreviewHost: ViewContainerRef;
  @ViewChild("deliveryDatePanel", { static: false }) deliveryDatePanel: OverlayPanel;
  _enabledEditMode = true;

  private emailSettings: StoreSettingEmail;
  enum_saledoc_fulfillment_status: SelectItem[];
  enum_saledoc_delivery_method: SelectItem[];
  enum_saledoc_delivery_status: SelectItem[];
  progressBar: DynamicDialogRef;

  Tender_Type = Tender_Type;
  purchaseDoc: PurchaseDoc;
  tendersPrettyPrint: string;
  _activeFullDialog: DialogName;
  _activeFullDialogExtra: any;
  footerFormGroup: UntypedFormGroup;
  _isStore: boolean;
  printSizesMenuItems: MenuItem[] = [];
  _currencyISOCode = "CAD";
  hasTakuPaymentTerminal: boolean;
  orderCreationDateObj: Date;
  isVoidDisabled = false;

  printMgr: PrintingMgr;
  _headerTitle = "";
  decimalFormat = "1.2-2";

  constructor(
    private fb: UntypedFormBuilder,
    appSettings: AppSettingsStorageService,
    protected _router: Router,
    printingMgrFactory: PrintingFactoryService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    protected confirmationService: ConfirmationService,
    private appSettingsService: AppSettingsStorageService,
    private messageService: MessageService,
    private alertMessagesService: AlertMessagesService,
    private dialogService: DialogService,
    public monerisService: MonerisService,
    private dbService: DBService,
    public takuPayService: TakuPayService,
    private clipboard: Clipboard
  ) {
    this._isStore = appSettings.getStoreId() ? true : false;
    this._currencyISOCode = appSettings.getZone().defaultCurrencyIsoCode;
    if (this.config && this.config.data && this.config.data._object) {
      this._object = this.config.data._object;
      this.accountName = this.config.data.accountName;
      this._enabledEditMode = this.config.data._enabledEditMode || this._enabledEditMode;
      this.purchaseDoc = PurchaseDoc.convertIntoTypedObject(this._object);

      this.printMgr = printingMgrFactory.build(appSettings.getStoreId());
    } else {
      this.printMgr = printingMgrFactory.build(appSettings.getStoreId());
    }
    this.footerFormGroup = this.fb.group({
      emailAddress: this.fb.control(null, Validators.email),
      docDate: this.fb.control(this.purchaseDoc ? this.purchaseDoc.doc.docDate : null),
    });

    if (this.purchaseDoc?.doc?.docDate) {
      this.orderCreationDateObj = moment(this.purchaseDoc.doc.docDate).toDate();
    } else {
      this.orderCreationDateObj = new Date();
    }
  }

  ngOnInit(): void {
    this.subsList.push(
      this.footerFormGroup.controls.docDate.valueChanges.pipe(pairwise()).subscribe(([prev, next]) => {
        if (prev != next) {
          this.onDocDateChanged();
          this.deliveryDatePanel.toggle(null, this.deliveryDatePanel.el.nativeElement);
        }
      })
    );
    this.printSizesMenuItems = [
      {
        label: "Receipt (Tape)",
        command: () => {
          // this.onReprintDoc(ReceiptPrintingSize.TAPE_SIZE);
        },
        icon: "takuicon-measuring-tape",
      },
      {
        label: "Receipt (Letter)",
        command: () => {
          // this.onReprintDoc(ReceiptPrintingSize.LETTER_SIZE);
        },
        icon: "takuicon-invoice",
      },
      {
        label: "Card Receipt",
        command: () => {
          // this.onReceiptCardPrintPressed();
        },
        icon: "text-3xl pi pi-credit-card",
      },
      {
        label: "Gift Receipt",
        command: () => {
          // this.onReprintGiftReceipt();
        },
        icon: "takuicon-gift",
      },
      {
        label: "Packing List (Tape)",
        command: () => {
          // this.onPrintPackingList(ReceiptPrintingSize.TAPE_SIZE);
        },
        icon: "takuicon-measuring-tape",
        disabled: this.purchaseDoc.doc.state === "Voided",
      },
      {
        label: "Packing List (Letter)",
        command: () => {
          // this.onPrintPackingList(ReceiptPrintingSize.LETTER_SIZE);
        },
        icon: "takuicon-invoice",
        disabled: this.purchaseDoc.doc.state === "Voided",
      },
      {
        label: "Prep Order (Tape)",
        command: () => {
          // Print prep
          // this.onPrintPrep();
        },
        icon: "takuicon-measuring-tape",
        disabled: this.purchaseDoc.doc.state === "Voided" || !this.appSettingsService.getStation()?.prepPrinter,
      },
    ];

    this.subsList.push(
      this.appSettingsService.getStoreSettings("storeSettingEmail").subscribe({
        next: (settings) => {
          this.emailSettings = settings;
        },
        error: (error) => {
          this.emailSettings = null;
        },
      })
    );

    this.ngOnChanges();
  }

  ngOnChanges(): void {
    this.purchaseDoc = PurchaseDoc.convertIntoTypedObject(this._object);
    this._headerTitle = `<span>DOC# ${this.purchaseDoc.doc.docNo} -&nbsp;</span><span style="color: orange;">${this.purchaseDoc.doc.state}</span>`;

    this.footerFormGroup.setValue({
      emailAddress: this.purchaseDoc?.account?.commercialAccount?.commercialAccountEmails[0]?.email || "",
      docDate: this.purchaseDoc.doc.docDate,
    });
    this.setIsVoidDisabled();
  }

  get sendEmailEnabled(): any {
    return this.emailSettings && this.emailSettings.id;
  }

  get _isMobile(): boolean {
    return WebHelpers.isMobileScreen();
  }

  get isVoided(): boolean {
    return this.purchaseDoc.doc.state === DocState.voided;
  }

  setIsVoidDisabled(): void {
    this.isVoidDisabled = this.isVoided;
  }

  onClosePressed(): void {
    this.dialogClosed.emit(this.purchaseDoc);
    if (this.ref) {
      this.ref.close();
    }
  }

  closeFullSizeDialog(): void {
    this._activeFullDialog = null;
  }

  // onPrintPackingList(printSize: ReceiptPrintingSize) {
  //   const _tempSaleDoc = Object.assign({}, this.purchaseDoc);
  //   _tempSaleDoc["isPackingList"] = true;
  //   this.printMgr.printDocumentsWithSize([_tempSaleDoc], this.printPreviewHost, printSize);
  // }

  // onPrintPrep() {
  //   this.printMgr.printStarCloudPRNTPrepInBatch([this.purchaseDoc]);
  // }

  // onReprintDoc(printSize: ReceiptPrintingSize) {
  //   if (PrintHelpers.isTakuPayTransaction(this.purchaseDoc)) {
  //     Object.assign(this.purchaseDoc, { isMerchantReceipt: false }, { isCustomerReceipt: true });
  //     this.printMgr.printDocumentsWithSize([this.purchaseDoc], this.printPreviewHost, printSize);
  //   } else {
  //     this.printMgr.printDocumentsWithSize([this.purchaseDoc], this.printPreviewHost, printSize);
  //   }
  // }

  onDocDateChanged(): void {
    this.dbService
      .patchRow("saleDoc", { id: this.purchaseDoc.id, "doc.docDate": this.footerFormGroup.get("docDate").value })
      .subscribe({
        next: () => {
          this.purchaseDoc.doc.docDate = this.footerFormGroup.get("docDate").value;

          this.messageService.add(this.alertMessagesService.getMessage("save-success"));
        },
        error: (error) => {
          this.footerFormGroup.reset(this.purchaseDoc);
          this.messageService.add(this.alertMessagesService.getErrorMessage(error));
        },
      });
  }

  onVoidPressed(): void {
    this.dbService
      .patchRow("purchaseDoc", {
        id: this.purchaseDoc.id,
        "doc.docDate": this.footerFormGroup.get("docDate").value,
      })
      .subscribe({
        next: () => {
          this.purchaseDoc.doc.docDate = this.footerFormGroup.get("docDate").value;
          this.messageService.add(this.alertMessagesService.getMessage("save-success"));
        },
        error: (error) => {
          this.footerFormGroup.reset(this.purchaseDoc);
          this.messageService.add(this.alertMessagesService.getErrorMessage(error));
        },
      });
  }

  // onEmailDoc(printSize: ReceiptPrintingSize) {
  //   this.subsList.push(
  //     this.printMgr
  //       .sendInvoiceEmail(this.purchaseDoc, this.emailAddressCtrl.value, this.printPreviewHost, printSize)
  //       .subscribe({
  //         next: (response) => {
  //           // Do nothing for NOW
  //         },
  //       })
  //   );
  // }

  openFullSizeDialog(dialog: DialogName, extra = null): void {
    this._activeFullDialog = dialog;
    this._activeFullDialogExtra = extra;
  }

  ngOnDestroy(): void {
    this.subsList.map((sub) => {
      sub.unsubscribe();
    });
  }

  copyEmailToClipboard(email: string): void {
    this.clipboard.copy(email);
  }

  openCustomerDetails(): void {
    this.config.data.account = this.purchaseDoc.account.commercialAccount;
    this.dialogService.open(AccountDialogWrapperComponent, this.config);
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
